import {init as initNew} from 'core/LifeCycle';
import {createSettings} from 'core/Settings';
import {STORAGE_STATE_KEY as storageKey} from 'shared/const';
import {getTodayStartTime} from 'shared/utils/dateTime';
import {storageProxy} from 'interactors/storageProxy';

function withLastRecalc(state: CoreState): StorableState {
  const lastRecalcDateTime = getTodayStartTime();
  return {...state, lastRecalcDateTime};
}

function ensureSettings(state: any): StorableState {
  // Миграция: добавляем settings, если его нет в старом состоянии
  if (!state.settings) {
    return {
      ...state,
      settings: createSettings(),
    };
  }
  return state;
}

export function fromStorage(storage: StorageService = storageProxy): StorableState {
  const savedState = storage.getItem(storageKey);
  const initedState = withLastRecalc(initNew());
  const rawState = savedState || initedState;
  const state = ensureSettings(rawState);

  storage.setItem(storageKey, state);
  return state;
}
